import {createActions} from "redux-actions";

const commonActions = createActions({
    SET_CURRENT_PARLOUR: undefined,
});

export default commonActions;